import { ReactComponent as HomeIcon } from "../../../Assets/icon/icon-home.svg";
import { ReactComponent as TrackIcon } from "../../../Assets/icon/icon-bar-chart.svg";
import { ReactComponent as DiscoverIcon } from "../../../Assets/icon/icon-clip.svg";
import { ReactComponent as ProfileIcon } from "../../../Assets/icon/icon-profile.svg";
import { ComponentType } from "react";
import { DiscoverTabs } from "types/enums";

interface SidebarItem {
  title: string;
  path: string;
  imgName: ComponentType<any>; // Changed from string to ComponentType
}
interface SidebarItems extends Array<SidebarItem> {}
const SidebarData: SidebarItems = [
  {
    title: "Home",
    path: "/user/home",
    imgName: HomeIcon,
  },
  {
    title: "Track",
    path: "/user/woneindex",
    imgName: TrackIcon,
  },
  {
    title: "Discover",
    path: `/user/discover?tab=${DiscoverTabs.SESSIONS}`,
    imgName: DiscoverIcon,
  },
  {
    title: "Profile",
    path: "/user/profile",
    imgName: ProfileIcon,
  },
];

export default SidebarData;
